module.exports = __webpack_public_path__ + "static/img/product_images_04_h5_zh.ba2291b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_04_h5_zh.png
// module id = kQb3
// module chunks = 34